(function () {
  function msg(key, fallback) { return (window.CS_KIDS_MESSAGES || {})[key] || fallback; }
  'use strict';
  function init() {
    var offer = document.querySelector('[data-cs-kids-offer]');
    var form = document.getElementById('cs-pform');
    if (!offer || !form || offer.dataset.initialized) return;
    offer.dataset.initialized = 'true';
    var dialog = offer.querySelector('[data-cs-express-dialog]');
    var pay = offer.querySelector('[data-cs-kids-checkout]');
    var error = offer.querySelector('[data-cs-offer-error]');
    var dialogError = offer.querySelector('[data-cs-express-error]');
    var recovery = offer.querySelector('[data-cs-cart-recovery]');
    var accept = offer.querySelector('[data-cs-express-accept]');
    var decline = offer.querySelector('[data-cs-express-decline]');
    var close = offer.querySelector('[data-cs-express-close]');
    var loading = offer.querySelector('[data-cs-offer-loading]');
    var busy = false;
    var checkoutState = null;
    var recoveryCheckout = null;
    var replaceCart = document.createElement('button');
    replaceCart.type = 'button';
    replaceCart.className = 'cs-btn cs-btn-block cs-bundle-checkout';
    replaceCart.textContent = 'Keep only my selected movies and continue';
    replaceCart.hidden = true;
    recovery.insertAdjacentElement('afterend', replaceCart);
    var second = function () { return offer.csSecondMovie; };
    var bundled = function () { return chosen() && chosen().value === 'bundle'; };
    var demo = function () { return form.dataset.offerDemo === 'true'; };
    function bundleMessage(key) { return (offer.csBundleMessages || {})[key] || offer.dataset.error; }
    var route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var currency = offer.dataset.currency || 'USD';
    var format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
    var money = function (cents) { return format.format(Number(cents) / 100); };
    var chosen = function () { return offer.querySelector('input[name="cs_kids_tier"]:checked'); };
    function publish(name, extra) {
      try {
        if (!demo() && window.Shopify && !window.Shopify.designMode && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('craftstory_' + name, Object.assign({ product_id: offer.dataset.productId, package: chosen().value }, extra || {}));
        }
      } catch (err) {}
    }
    function message(text) {
      [error, dialogError].forEach(function (el) { el.textContent = text || ''; el.hidden = !text; });
    }
    function select() {
      var tier = chosen();
      if (!tier) return;
      form.elements.namedItem('id').value = tier.dataset.variantId || '';
      pay.textContent = offer.dataset.checkoutLabel + ' — ' + money(Number(tier.dataset.price) + (second() ? second().amount() : 0));
      offer.querySelector('[data-cs-express-total]').textContent = money(Number(tier.dataset.price) + Number(offer.dataset.expressPrice) + (second() ? second().amount() : 0));
      var note = offer.querySelector('[data-cs-second-express-note]');
      if (note) note.hidden = !(second() && second().current());
      message('');
    }
    function lock(state) {
      busy = state;
      if (second()) second().lock(state);
      [pay, accept, decline, close, replaceCart].forEach(function (el) { el.disabled = state; });
      offer.querySelectorAll('input[name="cs_kids_tier"]').forEach(function (el) { el.disabled = state; });
      loading.hidden = !state;
      form.setAttribute('aria-busy', String(state));
    }
    function ready() {
      var secondError = second() && second().ready();
      if (secondError) { message(secondError); return false; }
      if (!demo() && (form.dataset.previewReady !== 'true' || !previewId())) { message(msg('checkout_wait', 'Please wait until your preview is complete.')); return false; }
      var tier = chosen();
      if (!tier || !tier.dataset.variantId || tier.dataset.available !== 'true') {
        message(offer.dataset.unavailable);
        return false;
      }
      return true;
    }
    function previewId() {
      var el = form.querySelector('[name="properties[_Preview ID]"]');
      return el ? el.value : '';
    }
    function buildData(express, requestId) {
      var tier = chosen();
      var source = new FormData(form);
      var data = new FormData();
      var savedPhoto = source.get('properties[_Child Photo URL]');
      data.set('items[0][id]', tier.dataset.variantId);
      data.set('items[0][quantity]', '1');
      source.forEach(function (value, key) {
        if (/^properties\[[^\]]+\]$/.test(key)) {
          if (savedPhoto && key === 'properties[Photo 1]') return;
          if (typeof value === 'string' || (value && value.size)) data.append('items[0][' + key.replace('[', ']['), value);
        }
      });
      if (savedPhoto) data.set('items[0][properties][Photo 1]', savedPhoto);
      var properties = {
        'Package': bundled() ? '3-movie pack' : 'Standard',
        'Delivery': express ? '30-minute express delivery' : 'Standard delivery',
        '_cs_offer_version': 'kids-bundle-2026-10-22',
        '_cs_checkout_id': requestId,
        '_cs_kids_package': 'standard',
        '_cs_bundle': bundled() ? '3-for-69' : 'single',
        '_cs_kids_resolution': '480p',
        '_cs_kids_express': express ? 'true' : 'false'
      };
      if (bundled()) {
        properties['Free gifts'] = '2 personalized songs + 3 adventure coloring pages';
        properties['_cs_kids_coloring_pages'] = '3';
        properties['_cs_kids_personalized_songs'] = '2';
      }
      Object.keys(properties).forEach(function (key) { data.set('items[0][properties][' + key + ']', properties[key]); });
      if (second()) second().append(data, properties, requestId);
      var expressIndex = 1 + (second() ? second().extras().length : 0);
      if (express) {
        data.set('items[' + expressIndex + '][id]', offer.dataset.expressId);
        data.set('items[' + expressIndex + '][quantity]', '1');
        data.set('items[' + expressIndex + '][properties][_cs_checkout_id]', requestId);
        data.set('items[' + expressIndex + '][properties][_cs_movie_variant]', tier.dataset.variantId);
        data.set('items[' + expressIndex + '][properties][_cs_express_scope]', 'all_movies');
        data.set('items[' + expressIndex + '][properties][_cs_movie_variants]', JSON.stringify([tier.dataset.variantId].concat(second() ? second().extras().map(function(item){return item.variantId;}) : [])));
        data.set('items[' + expressIndex + '][properties][_Preview ID]', previewId());
        data.set('items[' + expressIndex + '][properties][_cs_offer_version]', 'kids-2026-09-30');
      }
      return data;
    }
    function request(url, options) {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 25000);
      return fetch(url, Object.assign({}, options, {signal:controller.signal})).finally(function(){clearTimeout(timer);});
    }
    function checkCart(cart, requestId, express) {
      var items = (cart.items || []).filter(function (item) { return item.properties && item.properties._cs_checkout_id === requestId; });
      var extras = second() ? second().extras() : [];
      var movie = items.find(function (item) { return String(item.variant_id) === String(chosen().dataset.variantId) && (!item.properties._cs_movie_role || item.properties._cs_movie_role === 'primary') && item.quantity === 1; });
      var extraItems = extras.map(function(extra){return items.find(function(item){return String(item.variant_id)===String(extra.variantId) && item.properties._cs_personalization_id===extra.personalizationId && item.quantity===1;});});
      var addon = items.find(function(item){return String(item.variant_id)===String(offer.dataset.expressId) && item.quantity===1;});
      var complete = !!movie && extraItems.every(Boolean) && (!express || !!addon) && items.length===1+extras.length+(express?1:0);
      var unrelated = (cart.items || []).filter(function(item) { return items.indexOf(item) === -1; });
      var total = Number(cart.total_price);
      var priced = cart.currency === currency && Number.isSafeInteger(total) && total >= 0;
      return {complete:complete, count:items.length, cart:cart, unrelated:unrelated, discounted:!bundled() || (extras.length===2 && unrelated.length===0 && priced)};
    }
    async function updateCart(payload) {
      var response = await request(route + 'cart/update.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(payload)});
      if (!response.ok) throw new Error(offer.dataset.unknownError);
      return response.json();
    }
    function previousAttemptKeys(cart, requestId, replaceCurrent) {
      var groups = {};
      (cart.items || []).forEach(function(item) {
        var p = item.properties || {};
        var samePreview = p['_Preview ID'] === previewId() || p._cs_source_preview_id === previewId();
        if (p._cs_checkout_id && samePreview && (p._cs_checkout_id !== requestId || replaceCurrent)) groups[p._cs_checkout_id] = true;
      });
      if (replaceCurrent) groups[requestId] = true;
      var updates = {};
      (cart.items || []).forEach(function(item) {
        if (item.properties && groups[item.properties._cs_checkout_id]) updates[item.key] = 0;
      });
      return updates;
    }

    async function inspectCart(requestId, express) {
      var response = await request(route + 'cart.js', { credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'} });
      if (!response.ok) throw new Error('cart_unavailable');
      return checkCart(await response.json(), requestId, express);
    }
    async function finishCheckout(requestId, express, checked) {
      checked = checked || await inspectCart(requestId, express);
      if (!checked.complete) throw new Error(offer.dataset.unknownError);
      if (bundled()) {
        if (checked.unrelated.length) {
          recoveryCheckout = {requestId:requestId, express:express};
          replaceCart.hidden = false;
          throw new Error('Your cart also contains an earlier selection. Keep only your selected movies to continue with the $69 pack, or review your cart.');
        }
        // The pack discount is automatic. Do not reapply legacy bundle codes
        // or make a correctly priced cart depend on another network request.
        if (!checked.discounted) {
          var family = second().discountCodes.map(function(code){return String(code).toUpperCase();});
          var active = checked.cart.discount_codes || [];
          var codes = active.filter(function(d){return d.applicable !== false && family.indexOf(String(d.code).toUpperCase()) === -1;}).map(function(d){return d.code;});
          if (active.some(function(d){return family.indexOf(String(d.code).toUpperCase()) !== -1;})) {
            checked = checkCart(await updateCart({discount:codes.join(',')}), requestId, express);
          }
          // One fresh read covers Shopify recalculation after a cart mutation.
          if (!checked.discounted) checked = await inspectCart(requestId, express);
          if (!checked.complete || !checked.discounted) throw new Error(second().discountError);
        }
      }
      publish('kids_checkout_started', {express:express, preview_id:previewId(), second_movie:!!(second() && second().current()), value:(Number(chosen().dataset.price) + (second() ? second().amount() : 0) + (express ? Number(offer.dataset.expressPrice) : 0))/100, currency:currency});
      window.location.assign(route + 'checkout');
    }
    async function checkout(express) {
      if (busy || !ready()) return false;
      if (demo()) { message(bundleMessage('demo_checkout')); return false; }
      if (bundled() && offer.dataset.packCheckoutEnabled !== 'true') { message(bundleMessage('discount_pending')); return false; }
      if (express && (!offer.dataset.expressId || offer.dataset.expressAvailable !== 'true')) return false;
      lock(true); message(''); recovery.hidden = true; replaceCart.hidden = true; recoveryCheckout = null;
      var storageKey = 'cs-bundle-checkout:' + previewId();
      var extra = second() && second().current();
      var signature = [chosen().value,chosen().dataset.variantId,second() ? second().extras().map(function(item){return item.personalizationId;}).join(',') : '',express].join(':');
      try { checkoutState = checkoutState || JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (e) {}
      var requestId = checkoutState ? checkoutState.requestId : crypto.randomUUID();
      var attempted = !!checkoutState;
      try {
        var previous = await inspectCart(requestId, express);
        var replaceCurrent = !!checkoutState && (checkoutState.signature !== signature || (previous.count > 0 && !previous.complete));
        var updates = previousAttemptKeys(previous.cart, requestId, replaceCurrent);
        if (Object.keys(updates).length) previous = checkCart(await updateCart({updates:updates}), requestId, express);
        if (previous.count) {
          if (!previous.complete || !checkoutState || checkoutState.signature !== signature) throw new Error(offer.dataset.unknownError);
          await finishCheckout(requestId, express, previous); return true;
        }
        checkoutState = {requestId:requestId, signature:signature};
        try { sessionStorage.setItem(storageKey,JSON.stringify(checkoutState)); } catch (e) {}
        attempted = true;
        var response = await request(route + 'cart/add.js', {method:'POST', credentials:'same-origin', headers:{Accept:'application/json'}, body:buildData(express,requestId)});
        if (!response.ok) {
          var failure = await response.json().catch(function(){return {};});
          var checked = await inspectCart(requestId,express);
          if (!checked.count) {
            checkoutState = null; attempted = false;
            try {sessionStorage.removeItem(storageKey);} catch(e) {}
            throw new Error(typeof failure.description === 'string' ? failure.description : offer.dataset.error);
          }
        }
        await finishCheckout(requestId, express);
        return true;
      } catch (err) {
        if (attempted) {
          if (!recoveryCheckout && err.message !== (second() && second().discountError)) {
            try {
              var recovered = await inspectCart(requestId, express);
              if (recovered.complete && checkoutState.signature === signature) { await finishCheckout(requestId, express, recovered); return true; }
            } catch (recoveryError) { err = recoveryError; }
          }
          message(recoveryCheckout || err.message === (second() && second().discountError) ? err.message : offer.dataset.unknownError);
          recovery.hidden = false; dialog.close(); lock(false);
          return false;
        }
        message(err.message || offer.dataset.error); lock(false);
        return false;
      }
    }
    replaceCart.addEventListener('click', async function() {
      if (busy || !recoveryCheckout) return;
      var target = recoveryCheckout;
      lock(true); message('');
      try {
        var checked = await inspectCart(target.requestId, target.express);
        if (!checked.complete) throw new Error(offer.dataset.unknownError);
        var updates = {};
        checked.unrelated.forEach(function(item){updates[item.key] = 0;});
        if (Object.keys(updates).length) checked = checkCart(await updateCart({updates:updates}), target.requestId, target.express);
        replaceCart.hidden = true; recoveryCheckout = null;
        await finishCheckout(target.requestId, target.express, checked);
      } catch (err) {
        message(err.message || offer.dataset.error);
        recovery.hidden = false;
        lock(false);
      }
    });
    function showExpressOffer() {
      if (offer.dataset.expressAvailable !== 'true' || !offer.dataset.expressId) return false;
      select();
      if (second()) second().hide();
      dialog.showModal();
      publish('kids_express_offer_viewed');
      return true;
    }
    offer.csCheckoutSecond = async function () {
      publish('kids_checkout_clicked', {source:'second_movie'});
      if (busy || !ready()) return {started:false, error:error.textContent};
      if (showExpressOffer()) return {offered:true};
      var started = await checkout(false);
      return {started:started, error:error.textContent, recovery:!recovery.hidden};
    };
    offer.addEventListener('cs:second-changed', select);
    function requestCheckout() {
      if (busy) return;
      if (bundled() && second()) { second().open(); return; }
      if (!ready()) return;
      publish('kids_checkout_clicked');
      if (!showExpressOffer()) checkout(false);
    }
    pay.addEventListener('click',function(event){event.preventDefault();requestCheckout();});
    offer.querySelectorAll('.cs-kids-tier').forEach(function (card) {
      card.addEventListener('click', function (event) {
        var radio = card.querySelector('input[name="cs_kids_tier"]');
        if (!radio || event.target === radio || event.target.closest('a,button,select,textarea')) return;
        event.preventDefault();
        if (busy || radio.disabled) return;
        var changed = !radio.checked;
        radio.checked = true;
        radio.focus({ preventScroll: true });
        if (changed) radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    offer.querySelectorAll('input[name="cs_kids_tier"]').forEach(function (radio) {
      radio.addEventListener('change', function () { select(); publish('kids_package_selected'); });
    });
    form.addEventListener('submit', function (event) {
      if (event.defaultPrevented) return;
      event.preventDefault();
      var unlock = form.querySelector('[data-step="unlock"]');
      if (unlock && unlock.hidden) return;
      requestCheckout();
    });
    accept.addEventListener('click', function () { publish('kids_express_accepted'); checkout(true); });
    decline.addEventListener('click', function () { publish('kids_express_declined'); checkout(false); });
    close.addEventListener('click', function () { if (!busy) dialog.close(); });
    dialog.addEventListener('cancel', function (event) { if (busy) event.preventDefault(); event.stopPropagation(); });
    dialog.addEventListener('keydown', function (event) { if (event.key === 'Escape') event.stopPropagation(); });
    dialog.addEventListener('close', function () { if (!busy) pay.focus({ preventScroll: true }); });
    var defaultPremium=offer.querySelector('input[name="cs_kids_tier"][value="bundle"][data-available="true"]');
    if(defaultPremium)defaultPremium.checked=true;
    select();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();



